<script>
  import ProductCategory from "./ProductCategory.svelte";

  export let catList;
</script>

<style>

</style>

{#each catList as clist, index}
  <ProductCategory
    key={index}
    name={clist.name}
    count={clist.count}
    on:onCategorySelected />
{/each}
